import { RecognizeProfileDetails } from "@redotech/redo-recognize-common/profile-details";
import { RecognizeVipCursor } from "@redotech/redo-recognize-common/vip-profile";
import * as z from "zod";

export const getRecognizeProfileDetails = {
  name: "getRecognizeProfileDetails" as const,
  input: z.object({ profileId: RecognizeVipCursor.shape.id }),
  output: RecognizeProfileDetails,
};
